export default __webpack_public_path__ + "static/media/icon-search-grey.83243145.svg";